export default function DeleteAccount() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <h1 className="mb-4 font-montserrat text-3xl font-bold text-slate-900">Delete Your Account</h1>
      <div className="prose prose-slate max-w-none text-slate-600">
        <p>
          You can request deletion of your SHUWA account and associated data at any time. This page
          describes how to do it and what happens to your data.
        </p>

        <h2>How to request deletion</h2>
        <p>
          Email{" "}
          <a href="mailto:support@shuwa.app?subject=Account%20Deletion%20Request">support@shuwa.app</a>{" "}
          from the email address registered on your account with the subject "Account Deletion
          Request" and we will delete your account and data as described below.
        </p>
        <p>
          We verify each request against the account holder before processing it. We will confirm by
          email once your account has been deleted.
        </p>

        <h2>What gets deleted</h2>
        <p>Once your request is processed, we permanently delete or anonymize:</p>
        <ul>
          <li>Your profile information (name, email, phone number, photo)</li>
          <li>Saved favorites, loyalty cards, and gift cards</li>
          <li>Family &amp; friends connections tied to your account</li>
          <li>Login credentials and sessions</li>
        </ul>

        <h2>What we retain</h2>
        <p>
          Some information may be retained for a limited period where required by law, fraud
          prevention, or dispute resolution &mdash; for example:
        </p>
        <ul>
          <li>Booking and payment records, kept for accounting and tax compliance</li>
          <li>Records needed to resolve an open dispute, refund, or chargeback</li>
        </ul>
        <p>
          Retained records are kept only as long as necessary and are not used for any purpose other
          than legal or compliance obligations.
        </p>

        <h2>If you own a business on SHUWA</h2>
        <p>
          Deleting your account also closes and unpublishes your business listing. If your business
          has upcoming appointments booked, cancel or complete them from your business dashboard first
          &mdash; we won't delete an account with open bookings customers are relying on.
        </p>

        <h2>Timeline</h2>
        <p>
          Account deletion requests are processed within 30 days. This action is permanent and cannot
          be undone.
        </p>

        <h2>Questions?</h2>
        <p>
          Contact <a href="mailto:support@shuwa.app">support@shuwa.app</a> with any questions about
          this process.
        </p>
      </div>
    </div>
  );
}
